import { ModelsUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type fetchListAllDocumentsProps = {
  page: number
}

type filterListAllDocumentsProps = {
  page: number
  typeToDocument: string
  typeToService: string
}

type resetDocumentsProps = {
  cdTipoAvaliacao: number
  cdTypeToDocument: number
}

type deleteDocumentsProps = {
  id: number
}

export const fetchModelDocuments = ({
  cdTipoAvaliacao,
  cdTypeToDocument
}: resetDocumentsProps) => {
  return new ModelsUseCase(
    `/secao/load?cdTipoDocumento=${cdTypeToDocument}&cdTipoAvaliacao=${cdTipoAvaliacao}`,
    makeAxiosHttpClient()
  )
}

export const fetchListAllDocuments = ({
  page = 1
}: fetchListAllDocumentsProps) => {
  return new ModelsUseCase(`/secao?page=${page}`, makeAxiosHttpClient())
}

export const filterListAllDocuments = ({
  page = 1,
  typeToDocument,
  typeToService
}: filterListAllDocumentsProps) => {
  return new ModelsUseCase(
    `/secao/filter?tipoAvaliacao=${typeToService}&tipoDocumento=${typeToDocument}&page=${page}`,
    makeAxiosHttpClient()
  )
}

export const resetDocuments = ({
  cdTipoAvaliacao,
  cdTypeToDocument
}: resetDocumentsProps) => {
  return new ModelsUseCase(
    `/secao/reset?cdTipoAvaliacao=${cdTipoAvaliacao}&cdTipoDocumento=${cdTypeToDocument}`,
    makeAxiosHttpClient()
  )
}

export const fetchTagsDocumentsModel = () => {
  return new ModelsUseCase(`/secao/subtitle`, makeAxiosHttpClient())
}

export const saveDocumentsModel = () => {
  return new ModelsUseCase(`/secao/save`, makeAxiosHttpClient())
}

export const updateDocumentModel = () => {
  return new ModelsUseCase(`/secao/update`, makeAxiosHttpClient())
}

export const deleteDocumentModel = ({ id }: deleteDocumentsProps) => {
  return new ModelsUseCase(`/secao/delete/${id}`, makeAxiosHttpClient())
}

export const fetchTypeToDocument = () => {
  return new ModelsUseCase('/secao/load/tipoDocumento', makeAxiosHttpClient())
}

export const fetchTypeToService = () => {
  return new ModelsUseCase('/secao/load/tipoAvaliacao', makeAxiosHttpClient())
}
